import { Model } from 'ng2-app/modules/shared/models/model.class';

export class Comment extends Model<Comment> {

    id: number;
    activityId: number;
    borrowerId: number;
    content: string;
    created: number;
    modified: string;
    modifiedTimestamp: number;
    deleted: number;
    lenderUserId: number;
    lenderUserName: string;

    fillable(): string[] {
        return [
            'id',
            'activityId',
            'borrowerId',
            'content',
            'created',
            'modified',
            'deleted',
            'lenderUserId',
            'lenderUserName'
        ];
    }

    serializeable(): string[] {
        return this.fillable();
    }
}
